import { Chart } from '@antv/g2'
import { ListItem } from '@antv/component/lib/types'
import { CreateElement } from 'vue'
import {
  Vue,
  Component,
  Prop,
  Watch
} from 'vue-property-decorator'
import { PonitXY, BaseBarCfg3, G2TooltipCfg } from '@/types/common/g2Charts'
import { g2DefaultCfg, getAxisYName } from '../config'
import { comdify2 } from '@/utils/validate'
const { YAxisFn, annotationTextFn, colorList, defaultFill } = g2DefaultCfg
@Component
export default class InsideBarChart extends Vue {
  @Prop({ default: 500 }) height!: number
  @Prop() data!: PonitXY[]
  @Prop() options!: BaseBarCfg3
  @Prop({ default: 'stack' }) adjust!: string | string[]
  @Prop({ default: 'x*y' }) labelPosition!: string | string[]
  @Prop({ default: false }) coordinate!: boolean
  @Prop({ default: null }) paneValue!: number | null
  id = 'chart' + (Math.floor(Math.random() * 1000000) + 1)
  render (h: CreateElement) {
    return h('div', {
      attrs: {
        id: this.id
      }
    })
  }

  mounted () {
    setTimeout(() => {
      this.chart()
    })
  }

  @Watch('data', {
    deep: true
  })
  watchHandleChart () {
    this.chart()
  }

  @Watch('paneValue')
  watchHandleChartPaneValue (newValue: number, oldValue: number | null) {
    if (oldValue && oldValue !== newValue) {
      this.chart()
    }
  }

  chart () {
    const { chartCfgFn } = g2DefaultCfg

    const { data, options } = this
    const {
      annotationContent,
      legendPosition,
      // titleNextContent,
      // valueNextContent,
      position,
      barSize
      // yAxisHide
    } = options

    const dom = document.querySelector('#' + this.id)
    if (dom) {
      dom.innerHTML = ''
    }

    // 存放色值
    const _mapColor = new Map()

    const chart = new Chart({
      container: this.id,
      ...chartCfgFn([50, 50, 50, 100])
    })
    chart.data(data)
    if (legendPosition) {
      // 图例的位置
      // 'top' | 'top-left' | 'top-right' | 'right' | 'right-top' | 'right-bottom' | 'left' | 'left-top' | 'left-bottom' | 'bottom' | 'bottom-left' | 'bottom-right'
      chart.legend({
        position: legendPosition,
        itemName: {
          formatter (text: string, item: ListItem) {
            if (text !== 't1' && text !== 't2') {
              return text
            } else {
              (item.marker as { style: { r: number } }).style.r = 0
              return ''
            }
          }
        },
        marker: {}
      })
    }
    chart.tooltip({
      shared: true,
      showMarkers: false,
      customContent (title: string, data: G2TooltipCfg[]) {
        let html = ''
        data.forEach((item: G2TooltipCfg) => {
          const { name, value, data } = item
          html += `
                <li class='g2-tooltip-list-item'>
                    <span class='g2-tooltip-marker' style='background-color: ${
                      data.analyType === 't1'
                        ? defaultFill
                        : colorList()[
                            [..._mapColor.keys()].findIndex(
                              (item: string) => item === name
                            )
                          ]
                    }'></span>
                    <span class='g2-tooltip-name'>${name}</span>:<span class='g2-tooltip-value'>${value}</span>
                </li>
              `
        })
        return `<div class='g2-tooltip-title'>${title}</div>
                <ul class='g2-tooltip-list'>
                  ${html}
                </ul>`
        // return tooltipText3(
        //   title + (titleNextContent || ''),
        //   data,
        //   valueNextContent || ''
        // )
      }
    })

    this.coordinate &&
      chart.coordinate('theta', {
        radius: 0.85
      })

    chart.axis(getAxisYName(this.labelPosition as string), {
      ...YAxisFn(),
      label: {
        formatter (text: string) {
          return comdify2(text)
        }
      }
    })

    // if(yAxisHide) {
    //   let _y = ''
    //   console.log(this.labelPosition)

    //   if(this.labelPosition instanceof Array) {
    //     _y = this.labelPosition[1]
    //   }else {
    //     _y = this.labelPosition.split('*')[1]

    //   }

    //   chart.axis(_y, false)
    // }

    chart.interaction('active-region')

    if (barSize) {
      chart
        .interval()
        .adjust(this.adjust)
        .position(this.labelPosition)
        .color('type', colorList())

        .size('analyType', (k: string) => {
          if (k === barSize) {
            return 14
          }
          return 8
        })
        .label('value', () => {
          return {
            position: 'middle',
            offset: 0,
            content: () => {
              return ''
            },
            style: {
              stroke: '#fff'
            }
          }
        })
        .style('analyType*type', (value: string, type) => {
          if (value === 't1') {
            return {
              fill: defaultFill
            }
          } else {
            if (!_mapColor.has(type)) {
              _mapColor.set(type, true)
            }
            return {
              fill: colorList()[
                [..._mapColor.keys()].findIndex((item: string) => item === type)
              ]
            }
          }
        })
    } else {
      chart
        .interval()
        .adjust(this.adjust)
        .position(this.labelPosition)
        .color('type', colorList())
        .label('value', () => {
          return {
            position: 'middle',
            offset: 0,
            content: () => {
              return ''
            },
            style: {
              stroke: '#fff'
            }
          }
        })
    }

    chart.annotation().text({
      position,
      content: annotationContent,
      ...annotationTextFn({ offsetY: -20 })
    })

    chart.render()
  }
}
